"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDVSString = exports.useDVSNumber = exports.useDVSBoolean = exports.DVSClientProvider = exports.DVSClientContext = void 0;
var context_1 = require("./context");
Object.defineProperty(exports, "DVSClientContext", { enumerable: true, get: function () { return context_1.DVSClientContext; } });
Object.defineProperty(exports, "DVSClientProvider", { enumerable: true, get: function () { return context_1.DVSClientProvider; } });
var hooks_1 = require("./hooks");
Object.defineProperty(exports, "useDVSBoolean", { enumerable: true, get: function () { return hooks_1.useDVSBoolean; } });
Object.defineProperty(exports, "useDVSNumber", { enumerable: true, get: function () { return hooks_1.useDVSNumber; } });
Object.defineProperty(exports, "useDVSString", { enumerable: true, get: function () { return hooks_1.useDVSString; } });
//# sourceMappingURL=index.js.map